import { useSearchParamsFeatures } from "src/feature/internal/searchParams/useSearchParamsFeatures";
import { useBackendFeatureOverrideString } from "src/utils/hooks/useBackendFeatureOverrideString";

export function useFeatureOverride(): string | undefined {
  let featureOverride = useBackendFeatureOverrideString();
  const { Debug: debug } = useSearchParamsFeatures();
  if (debug) {
    // If the frontend `debug` feature is enabled, we want to enable the "ShowDebug" backend feature.
    // We want to do that here, instead of in the cookie, because we don't want it to persist.
    const splitFeatures =
      featureOverride.length > 0 ? featureOverride.split(",") : [];
    if (!featureOverride.includes("ShowDebug")) {
      splitFeatures.push("ShowDebug");
    }
    featureOverride = splitFeatures.join(",");
  }
  return featureOverride || undefined;
}
